<template>
    <div class="system">
      <head-top :navActive=2></head-top>
      <!-- 内容 start -->
      <div class="system-main">
        <div class="system-wrapper">
          <div class="system-wrapper-left">
            <div class="system-wrapper-left-top">
              <div class="system-wrapper-left-top-div">
                <p>查看销量排行</p>
                <p>Sales ranking</p>
              </div>
            </div>
            <div class="system-wrapper-left-list">
                <div class="system-wrapper-left-list-item"
              v-show="index<3"
               @click="systemDetailFun(item.id)"
               :style="{backgroundImage: 'url(' + item.img + ')' }"
               v-for="(item,index) in paperList"

               :key="item.id"></div>
            </div>
          </div>
          <div class="system-wrapper-right">
            <div class="system-wrapper-right-title">
              <span></span>
              <h2>论文查重</h2>
            </div>
            <ul class="system-wrapper-right-list">
              <li v-for="(item,index) in paperList" :key="index">
                <div class="system-right-list-title" @click="systemDetailFun(item.id)">
                  <h3>{{item.title}}</h3>
                  <p>{{item.name}}</p>
                </div>
                <p class="system-right-list-synopsis">{{item.desc}}</p>
                <div class="system-right-list-btn">
                  <p>{{item.price}}<span>元/篇</span></p>
                  <a @click="btnClickFun(item.id)">立即检测</a>
                </div>
                <div class="keynote-div">{{item.explain}}</div>
              </li>

            </ul>
          </div>
        </div>
      </div>
      <!-- 内容 end -->
      <foot-bottom></foot-bottom>
    </div>
</template>

<script>
  import headTop from '../components/header/head-top'
  import footBottom from '../components/footer/foot-bottom'
  import tool from './../assets/js/tool'
    export default {
        name: "ch-system",
        components: {
          headTop,
          footBottom
        },
        data(){
          return{
            peparPage:1,  //列表当前页
            peparPageSize:100,//每页展示多少条
            paperList:[],//论文产品列表

          }
        },
        created(){
          this.init()
        },
        methods: {
          // 初始化
          init(){
            this.getPaperList()
          },
          // 获取论文产品列表
          getPaperList(){
            let queryParams={
              page:this.peparPage,
              page_size:this.peparPageSize
            }
            tool.postData("get_goods_list",queryParams,res=>{
              this.paperList=res.data.data.goods_list.data
            })
          },

          systemDetailFun (id) {
            this.$router.push({
              path: '/chSystemDetail/',
              query:{
                id:id
              }
            })
          },
          btnClickFun (id) {
            this.$router.push({
              path: '/paperUpload/',
              query:{
                id:id
              }
            })
          }
        }
    }
</script>

<style scoped lang="scss">
  @import "../assets/style/common";
  .system{
    width: 100%;
    height: 100%;
    background-color: #eff4ff;
  }
  .system-main{
    width: 100%;
    background: url("../../static/img/nav.png") no-repeat top center;
    padding-top: 80px;
    box-sizing: border-box;
    margin-bottom: 60px;
    .system-wrapper{
      width: $box-width;
      margin: 0 auto;
      @include flex($align:flex-top);
      .system-wrapper-left{
        width: 289px;
        height: 661px;
        background-color: #fff;
        .system-wrapper-left-top{
          width: 100%;
          height: 90px;
          background-color: #3b6bda;
          display: flex;
          align-items: center;
          padding-left: 20px;
          box-sizing: border-box;
          .system-wrapper-left-top-div{
            border-left: 2px solid #fff;
            p{
             @include font(24px,#fff);
              margin-left: 10px;
            }
          }
        }
        .system-wrapper-left-list{
          padding: 19px;
          box-sizing: border-box;
          .system-wrapper-left-list-item{
            width: 100%;
            height: 159px;
            border-radius: 7px;
            margin-bottom: 20px;
            padding: 37px 10px 20px;
            box-sizing: border-box;
             background-repeat: no-repeat;
             background-size: 100% 100%;
             cursor:pointer;

            .icon{
              display: flex;
              align-items: center;
              span{
                @include font(18px,#fff);
                margin-left: 10px;
              }
            }
            .txt{
              @include font(16px,#fff);
              text-align: center;
              line-height: 25px;
              margin-top: 20px;
            }
            // &:nth-child(1){
            //   background: #3169e3 url("../../static/img/ts-img/edu-bg-wen.png") repeat;
            // }
            // &:nth-child(2){
            //   background: #ee3244 url("../../static/img/ts-img/edu-bg-wen.png") repeat;
            // }
            // &:nth-child(3){
            //   background: #f16d1a url("../../static/img/ts-img/edu-bg-wen.png") repeat;
            // }
          }
        }
      }
      .system-wrapper-right{
        width: 890px;
        background-color: #fff;
        padding: 0 18px;
        box-sizing: border-box;
        .system-wrapper-right-title{
          height: 85px;
          display: flex;
          align-items: center;
          span{
            width: 10px;
            height: 10px;
            background-color: #3b6bda;
          }
          h2{
            @include font(25px,#333);
            margin-left: 10px;
          }
        }
        .system-wrapper-right-list{
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          li{
            width: 418px;
            height: 290px;
            border: 2px solid #c1d2f7;
            border-radius: 10px;
            padding: 30px;
            box-sizing: border-box;
            position: relative;
            overflow: hidden;
            margin-bottom: 20px;
            .system-right-list-title{
              cursor: pointer;
              h3,p{
                @include font(20px,#333);
                line-height: 27px;
                font-weight:bold;
              }
            }
            .system-right-list-synopsis{
              @include font(16px,#666);
              line-height: 25px;
              margin-top: 8px;
            }
            .system-right-list-btn{
              @include flex;
              margin-top: 20px;
              p{
                @include font(36px,#3b6bda);
                span{
                  @include font(16px,#333);
                }
              }
              a{
                width: 160px;
                background-color: #fff;
                border: 1px solid #3b6bda;
                @include font(20px,#3b6bda);
                border-radius: 20px;
                line-height: 39px;
                text-align: center;
                cursor: pointer;
                font-weight: bold;
                &:hover{
                  background-color: #3b6bda;
                  color: #fff;
                }
              }
            }
            .keynote-div{
              width: 100%;
              line-height: 40px;
              text-align: center;
              @include font(14px,#fff);
              background-color: #6289e1;
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ch-system.vue